import { cva } from "../../../node_modules/.pnpm/class-variance-authority@0.7.1/node_modules/class-variance-authority/dist/index.js";
import { default as default2 } from "./PatternBackground.js";
const PATTERN_BACKGROUND_DIRECTION = {
  Top: "top",
  Bottom: "bottom",
  Left: "left",
  Right: "right",
  TopLeft: "top-left",
  TopRight: "top-right",
  BottomLeft: "bottom-left",
  BottomRight: "bottom-right"
}, PATTERN_BACKGROUND_VARIANT = {
  Grid: "grid",
  Dot: "dot",
  BigDot: "big-dot"
}, PATTERN_BACKGROUND_SPEED = {
  Default: 1e4,
  Slow: 25e3,
  Fast: 5e3
}, patternBackgroundVariants = cva("relative text-clip", {
  variants: {
    variant: {
      [PATTERN_BACKGROUND_VARIANT.Grid]: "bg-[linear-gradient(to_right,var(--foreground)_1px,transparent_1px),linear-gradient(to_bottom,var(--foreground)_1px,transparent_1px)]",
      [PATTERN_BACKGROUND_VARIANT.Dot]: "bg-[radial-gradient(var(--foreground)_1px,transparent_1px)]",
      [PATTERN_BACKGROUND_VARIANT.BigDot]: "bg-[radial-gradient(var(--foreground)_3px,transparent_3px)]"
    },
    size: {
      xs: "bg-[size:8px_8px]",
      sm: "bg-[size:16px_16px]",
      md: "bg-[size:24px_24px]",
      lg: "bg-[size:32px_32px]"
    }
  },
  defaultVariants: {
    variant: "grid",
    size: "md"
  }
}), PATTERN_BACKGROUND_MASK = {
  Ellipse: "ellipse",
  EllipseTop: "ellipse-top"
}, patternBackgroundMaskVariants = cva("bg-background", {
  variants: {
    mask: {
      [PATTERN_BACKGROUND_MASK.Ellipse]: "[mask-image:radial-gradient(ellipse_at_center,transparent,black_80%)]",
      [PATTERN_BACKGROUND_MASK.EllipseTop]: "[mask-image:radial-gradient(ellipse_at_top,transparent,black_80%)]"
    }
  },
  defaultVariants: {
    mask: "ellipse"
  }
});
export {
  PATTERN_BACKGROUND_DIRECTION,
  PATTERN_BACKGROUND_MASK,
  PATTERN_BACKGROUND_SPEED,
  PATTERN_BACKGROUND_VARIANT,
  default2 as PatternBackground,
  patternBackgroundMaskVariants,
  patternBackgroundVariants
};
//# sourceMappingURL=index.js.map
